// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';

export interface ChallengeReviewsRequestPayload {
  id: string;
  challenge: number;
  helpful: number;
  comments: string;
  condition: string;
}

export interface ChallengeReviewsFailPayload {
  error: Error;
}

export const postChallengeReviewsActions = createAsyncAction(
  'elearning/POST_CHALLENGE_REVIEWS_DATA',
  'elearning/POST_CHALLENGE_REVIEWS_DATA_SUCCESS',
  'elearning/POST_CHALLENGE_REVIEWS_DATA_FAIL'
)<ChallengeReviewsRequestPayload, void, ChallengeReviewsFailPayload>();
